import content from './siteContentReducer';
import team from './teamReducer';

const rootReducer = {
  content,
  team
};

export default rootReducer;
